import { Fingerprint, Shield } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from "../App.js";
import { loginPasskey, passkeyHostnameProblem, passkeysSupported } from "../lib/passkeys.js";

export function Login() {
  const { refresh } = useSession();
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    setErr(null);
    try {
      await loginPasskey();
      await refresh();
      nav("/", { replace: true });
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <div style={{ maxWidth: 420, margin: "60px auto 0" }}>
      <div style={{ textAlign: "center", marginBottom: 16 }}>
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: 16,
            background: "var(--accent-soft)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Shield size={26} color="var(--accent)" strokeWidth={2.2} />
        </div>
      </div>
      <div className="card" style={{ textAlign: "center" }}>
        <h2>Sign in</h2>
        <p className="muted">
          Use the passkey you created for this gateway. Confidants sign in here too.{" "}
          <Link to="/guide#keys">What is a passkey?</Link>
        </p>
        {!passkeysSupported() && <p className="error">This browser does not support passkeys.</p>}
        {passkeyHostnameProblem() && <p className="error">{passkeyHostnameProblem()}</p>}
        {err && <p className="error">{err}</p>}
        <button
          className="primary"
          onClick={go}
          disabled={busy}
          style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
        >
          <Fingerprint size={17} />
          {busy ? "Waiting for passkey…" : "Sign in with passkey"}
        </button>
      </div>
    </div>
  );
}
